<template>
  <div
    class="fixed bottom-0 flex items-center justify-center z-50 border rounded-lg shadow"
  >
    <div class="bg-base-100 rounded-lg p-4 w-80 flex flex-col gap-4">
      <h3 class="text-lg font-bold">调整笔刷大小</h3>

      <div class="flex flex-col gap-2">
        <div class="flex justify-between items-center">
          <span class="text-sm">像素: {{ localSize }}px</span>
          <div class="flex gap-2">
            <button
              class="btn btn-sm btn-square"
              @click="updateSize(-1)"
              :disabled="localSize <= 1"
            >
              <i class="iconify mdi--minus"></i>
            </button>
            <button
              class="btn btn-sm btn-square"
              @click="updateSize(1)"
              :disabled="localSize >= 10"
            >
              <i class="iconify mdi--plus"></i>
            </button>
          </div>
        </div>

        <input
          type="range"
          v-model="localSize"
          class="range range-primary"
          min="1"
          max="10"
          step="1"
          @input="$emit('update:size', Number(localSize))"
        />

        <!-- Size Presets -->
        <div class="grid grid-cols-5 gap-2 mt-2">
          <button
            v-for="size in [1, 2, 3, 4, 5]"
            :key="size"
            class="btn btn-sm"
            :class="{ 'btn-primary': localSize === size }"
            @click="
              localSize = size;
              $emit('update:size', size);
            "
          >
            {{ size }}
          </button>
        </div>
        <div class="grid grid-cols-5 gap-2">
          <button
            v-for="size in [6, 7, 8, 9, 10]"
            :key="size"
            class="btn btn-sm"
            :class="{ 'btn-primary': localSize === size }"
            @click="
              localSize = size;
              $emit('update:size', size);
            "
          >
            {{ size }}
          </button>
        </div>
      </div>

      <div class="flex justify-end gap-2 mt-4">
        <button class="btn btn-sm" @click="$emit('close')">关闭</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

const props = defineProps<{
  size: number;
}>();

const emit = defineEmits<{
  (e: "update:size", size: number): void;
  (e: "close"): void;
}>();

const localSize = ref(props.size);

watch(
  () => props.size,
  (newSize) => {
    localSize.value = newSize;
  }
);

const updateSize = (delta: number) => {
  const newSize = localSize.value + delta;
  if (newSize >= 1 && newSize <= 10) {
    localSize.value = newSize;
    emit("update:size", newSize);
  }
};
</script>
